import React, { useCallback, useRef, useState } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { getEnv } from "../../Helpers/Env";

type LatLng = { lat: number; lng: number };

const defaultContainerStyle = {
  width: "100%",
  height: "250px",
};

const DraggableMap = ({
  defaultCenter,
  callback = () => {},
  containerStyle = defaultContainerStyle,
}: any) => {

  const mapRef = useRef<google.maps.Map | null>(null);

  const [pinPosition, setPinPosition] = useState<LatLng>(defaultCenter);
  const [draggingPin, setDraggingPin] = useState(false);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: getEnv("GOOGLE_MAP_KEY") as string,
    libraries: ["places"],
  });

  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
  }, []);

  const getAddressFromLatLng = (lat: number, lng: number) => {
  const geocoder = new google.maps.Geocoder();

  geocoder.geocode(
    { location: { lat, lng } },
    (results, status) => {
      if (status === "OK" && results && results.length > 0) {
        const components = results[0].address_components;

        let city = "";
        let province = "";
        let region = "";
        let streetAddress1 = "";
        let streetAddress2 = "";

        components.forEach((c) => {
          if (c.types.includes("locality")) {
            city = c.long_name;
          }

          if (c.types.includes("administrative_area_level_2")) {
            province = c.long_name;
          }

          if (c.types.includes("administrative_area_level_1")) {
            region = c.long_name;
          }

          if (c.types.includes("route")) {
            streetAddress1 = c.long_name;
          }

          if (c.types.includes("sublocality")) {
            streetAddress2 = c.long_name;
          }
        });

        callback({
          lat,
          lng,
          city,
          province,
          region,
          streetAddress1,
          streetAddress2,
        });
      }
    }
  );
};


  const onMapDragEnd = () => {
    if (draggingPin) return;
    if (!mapRef.current) return;

    const c = mapRef.current.getCenter();
    if (!c) return;

    const newPos = {
      lat: c.lat(),
      lng: c.lng(),
    };
    

    setPinPosition(newPos);
    // callback(newPos);
    getAddressFromLatLng(newPos.lat, newPos.lng);
  };

  const handlePinDrag = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!mapRef.current) return;

    setDraggingPin(true);

    const mapDiv = mapRef.current.getDiv();
    const rect = mapDiv.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const projection = mapRef.current.getProjection();
    const bounds = mapRef.current.getBounds();

    if (!projection || !bounds) return;

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const lng = sw.lng() + (x / rect.width) * (ne.lng() - sw.lng());
    const lat = ne.lat() - (y / rect.height) * (ne.lat() - sw.lat());

    const newPos = { lat, lng };

    setPinPosition(newPos);
    // callback(newPos);
    getAddressFromLatLng(newPos.lat, newPos.lng);
  };

  const stopPinDrag = () => {
    setDraggingPin(false);
  };

  return (
    <>
      {isLoaded && (
        <div
          style={{
            position: "relative",
            width: containerStyle.width,
            height: containerStyle.height,
          }}
        >
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={pinPosition}
            zoom={15}
            onLoad={onLoad}
            onDragEnd={onMapDragEnd}
            options={{
              gestureHandling: "greedy",
              fullscreenControl: true,
            }}
          />

          <div
            draggable
            onDrag={handlePinDrag}
            onDragEnd={stopPinDrag}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -100%)",
              fontSize: "36px",
              cursor: "grab",
              zIndex: 999,
              userSelect: "none",
            }}
          >
            📍
          </div>
        </div>
      )}
    </>
  );
};

export default DraggableMap;